import { render, staticRenderFns } from "./RecipientHousing.vue?vue&type=template&id=135967d2&"
import script from "./RecipientHousing.vue?vue&type=script&lang=js&"
export * from "./RecipientHousing.vue?vue&type=script&lang=js&"
import style0 from "./RecipientHousing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports